import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import HeroFinal from "../../../images/hero_final_final_fiiiiinal.png";
import { ArrowRightAlt } from "@material-ui/icons";
import { Container } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    height: "120vh",
    backgroundColor: "#000000",
  },
  mainPart: {
    height: "100%",
    width: "100%",
    color: theme.palette.text.hint,
  },
  pageTop: {
    height: "55vh",
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  assignTip: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageBottom: {
    height: "40vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    backgroundImage: 'url(' + require('../../../images/rainbow.svg') + ')',
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 99%",
    "& img": {
      width: "100%",
    },
  },
  smallLogo: {
    height: 23,
  },
  logoSlogan: {
    fontSize: 64,
    fontWeight: 800,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoBody: {
    fontSize: 18,
    fontWeight: 500,
    color: theme.palette.text.hint,
  },
  logoBody2: {
    fontSize: 18,
    fontWeight: 500,
    color: theme.palette.text.hint,
  },
  buttonInfoToMore: {
    fontSize: 16,
    marginTop: theme.spacing(5),
    borderColor: theme.palette.text.hint,
    color: theme.palette.text.hint,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    textTransform: "Capitalize",
  },
  buttonInfoToDocs: {
    fontSize: 16,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(5),
    borderColor: theme.palette.text.hint,
    color: theme.palette.text.hint,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    textTransform: "Capitalize",
  },
  buttonInfoToAssign: {
    color: theme.palette.text.hint,
    borderColor: theme.palette.text.hint,
    borderRadius: 0,
    "&:hover": {
      color: "white",
      borderColor: "white",
    },
    padding: "0 8px",
    textTransform: "Capitalize",
  },
  buttonInfoToData: {
    borderColor: "#ab42ff",
    borderRadius: 4,
    textTransform: "Capitalize",
    padding: "0 8px",
    color: theme.palette.text.hint,
    marginRight: theme.spacing(2),
  },
  mainTitle: {
    display: "flex",
    color: theme.palette.text.primary,
    justifyContent: "center",
  },
}));

export default function Feature1() {
  const classes = useStyles();

  const defaultSystemName = "Data Intelligence Platform";
  const tips = "How mature is your app with data and AI? Take this quiz to find out - and get to the next level."
  const sloganBody = "Take a unified approach to Infrastructure and Security Lifecycle Management."

  return (
    <Container maxWidth="lg">
      <div className={classes.root}>
        <Grid container className={classes.mainPart}>
          <Grid item xs={12} md={12}>
            <div className={classes.pageTop}>
              <div>
                <div className={classes.assignTip}>
                  <Button
                    variant={"outlined"}
                    className={classes.buttonInfoToData}
                  >
                    Cloud assessment
                  </Button>
                  {tips}
                  <Button
                    endIcon={<ArrowRightAlt />}
                    variant={"text"}
                    className={classes.buttonInfoToAssign}
                    onClick={() => window.open("https://cloud.labillion.cn", "_blank")}
                  >
                    Start
                  </Button>
                </div>
                <p className={classes.logoSlogan} id="slogan">
                  {defaultSystemName}
                </p>
              </div>
              <div>
                <p className={classes.logoBody}>
                  {sloganBody}
                </p>
              </div>
              <div>
                <Button
                  endIcon={<ArrowRightAlt />}
                  variant={"outlined"}
                  className={classes.buttonInfoToMore}
                  onClick={() => window.open("https://megaai.data.labillion.cn", "_blank")}
                >
                  Quick Start
                </Button>
                <Button
                  endIcon={<ArrowRightAlt />}
                  variant={"text"}
                  className={classes.buttonInfoToDocs}
                  onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}
                >
                  Documentation
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className={classes.pageBottom}>
              <img src={HeroFinal} alt="hero-final" />
            </div>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}